import { SET_CONTENT_CARDS } from '../Types';

const initialState = {
  allContentCards: [],
};

// reducer
export const contentCards = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTENT_CARDS:
      return {
        ...state,
        allContentCards: [...action.payload],
      };
    default:
      return state;
  }
};
